(function(){
if(window.__wvHdr){return}
window.__wvHdr=1;
var SEL='.mob_search,.desk_search',INP='input[type="search"],input[name="q"]';
var keep=false;
var touched=false;
function mark(){touched=true}
['pointerdown','touchstart','mousedown','keydown'].forEach(function(n){document.addEventListener(n,mark,{passive:true,capture:true})});
function boxes(){return document.querySelectorAll(SEL)}
function setOpen(b,on){
 if(!b){return}
 if(!on&&keep){return}
 b.classList.toggle('wv-open',on);
}
function closeAll(except){
 var l=boxes();
 for(var i=0;i<l.length;i++){if(l[i]!==except){setOpen(l[i],false)}}
}
function typing(b,input){b.classList.toggle('wv-typing',String((input&&input.value)||'').trim()!=='')}
document.addEventListener('focusin',function(e){
 if(!touched){return}
 var b=e.target.closest&&e.target.closest(SEL);
 if(b&&e.target.matches(INP)){closeAll(b);typing(b,e.target);setOpen(b,true)}
});
document.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest(SEL);
 if(e.target.closest('.wv-trend-x')){
  e.preventDefault();
  if(b){setOpen(b,false);var i=b.querySelector(INP);if(i){i.blur()}}
  return;
 }
 if(b){
  if(e.target.matches(INP)){closeAll(b);typing(b,e.target);setOpen(b,true)}
  return;
 }
 closeAll(null);
});
document.addEventListener('keydown',function(e){
 if(e.key==='Escape'){
  var l=boxes();
  for(var i=0;i<l.length;i++){if(l[i].classList.contains('wv-open')){setOpen(l[i],false);var f=l[i].querySelector(INP);if(f){f.blur()}}}
 }
});
document.addEventListener('input',function(e){
 if(!touched){return}
 var b=e.target.closest&&e.target.closest(SEL);
 if(b){typing(b,e.target);if(!b.classList.contains('wv-open')){setOpen(b,true)}}
});
window.addEventListener('pageshow',function(e){if(e.persisted){closeAll(null)}});
function settle(){
 if(keep||touched){return}
 closeAll(null);
 var a=document.activeElement;
 if(a&&a.matches&&a.matches(INP)&&a.closest(SEL)){a.blur()}
}
window.addEventListener('load',function(){settle();setTimeout(settle,400);setTimeout(settle,1200)});
if(keep){
 var openKept=function(){var l=boxes();for(var i=0;i<l.length;i++){setOpen(l[i],true)}};
 if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',openKept)}else{openKept()}
}
})();
